module.exports = __webpack_public_path__ + "img/multiplier.b8026910.png";